import {
  SET_CURRENT_CALL_LIST,
  SET_TAGS,
  SET_TASK_PAGE,
  SET_TASKS,
  RETRIEVE_RECORDS_STARTED
} from '../actions/search';

export default (state, action) => {
  state = state || {};

  switch (action.type) {
  case RETRIEVE_RECORDS_STARTED:
    return { ...state, isFetching: true };
  case SET_TASK_PAGE:
    return {
      ...state,
      hasNextPage: action.hasNextPage,
      lastPageLoaded: action.page
    };
  case SET_CURRENT_CALL_LIST:
    return {
      ...state,
      currentCallList: action.callList,
      isFetching: false
    };
  case SET_TASKS:
    return { ...state, tasks: action.tasks, isFetching: false };
  case SET_TAGS:
    return { ...state, tags: action.tags };
  default:
    return state;
  }
};
